// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2023 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import CustomerOrderListModel from '../../model/customer-order-list-model';
import CustomerOrderListDTO from '../dto/customer-order-list-dto';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class CustomerOrderListModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<CustomerOrderListDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.creatorId = data.creatorId;
      this.creatorName = data.creatorName ?? undefined;
      this.created = data.created;
      this.modifierId = data.modifierId ?? undefined;
      this.modifierName = data.modifierName ?? undefined;
      this.modified = data.modified ?? undefined;
      this.employeeId = data.employeeId;
      this.employeeNumber = data.employeeNumber ?? undefined;
      this.employeeName = data.employeeName ?? undefined;
      this.employeeEmail = data.employeeEmail ?? undefined;
      this.customerId = data.customerId;
      this.customerNumber = data.customerNumber ?? undefined;
      this.customerName = data.customerName ?? undefined;
      this.customerShortName = data.customerShortName ?? undefined;
      this.orderDate = data.orderDate;
      this.deliveryDate = data.deliveryDate;
      this.comment = data.comment ?? undefined;
      this.orderItemsCount = data.orderItemsCount;
      this.orderType = data.orderType ?? undefined;
      this.orderState = data.orderState;
      this.orderSentMessage = data.orderSentMessage ?? undefined;
      this.orderSentAt = data.orderSentAt ?? undefined;
    }
  }
  /**
  * @type {int64}
  */
  'id'?: number;
  /**
  */
  'links'?: ResourceLinkModel[];
  /**
  * @type {int64}
  */
  'creatorId'?: number;
  /**
  */
  'creatorName'?: string;
  /**
  * @type {date-time}
  */
  'created'?: string;
  /**
  * @type {int64}
  */
  'modifierId'?: number;
  /**
  */
  'modifierName'?: string;
  /**
  * @type {date-time}
  */
  'modified'?: string;
  /**
  * @type {int64}
  */
  'employeeId'?: number;
  /**
  */
  'employeeNumber'?: string;
  /**
  */
  'employeeName'?: string;
  /**
  */
  'employeeEmail'?: string;
  /**
  * @type {int64}
  */
  'customerId'?: number;
  /**
  */
  'customerNumber'?: string;
  /**
  */
  'customerName'?: string;
  /**
  */
  'customerShortName'?: string;
  /**
  * @type {date-time}
  */
  'orderDate'?: string;
  /**
  * @type {date-time}
  */
  'deliveryDate'?: string;
  /**
  */
  'comment'?: string;
  /**
  * @type {int32}
  */
  'orderItemsCount'?: number;
  /**
  */
  'orderType'?: string;
  /**
  * @type {int32}
  */
  'orderState'?: 0 | 1 | 2 | 3 | 4; // OrderStateDTO
  /**
  */
  'orderSentMessage'?: string;
  /**
  * @type {date-time}
  */
  'orderSentAt'?: string;

  static toModel(dto: DeepPartial<CustomerOrderListDTO>): CustomerOrderListModel;
  static toModel(dto: DeepPartial<CustomerOrderListDTO> | undefined | null): CustomerOrderListModel | undefined;
  static toModel(dto: DeepPartial<CustomerOrderListDTO> | undefined | null): CustomerOrderListModel | undefined {
    return dto ? new CustomerOrderListModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<CustomerOrderListModel> | CustomerOrderListModel) {
    const unwrapped = unwrapDataRecord(model);
    return {
      'id': unwrapped.id,
      'links': unwrapped.links,
      'creatorId': unwrapped.creatorId,
      'creatorName': unwrapped.creatorName,
      'created': unwrapped.created,
      'modifierId': unwrapped.modifierId,
      'modifierName': unwrapped.modifierName,
      'modified': unwrapped.modified,
      'employeeId': unwrapped.employeeId,
      'employeeNumber': unwrapped.employeeNumber,
      'employeeName': unwrapped.employeeName,
      'employeeEmail': unwrapped.employeeEmail,
      'customerId': unwrapped.customerId,
      'customerNumber': unwrapped.customerNumber,
      'customerName': unwrapped.customerName,
      'customerShortName': unwrapped.customerShortName,
      'orderDate': unwrapped.orderDate,
      'deliveryDate': unwrapped.deliveryDate,
      'comment': unwrapped.comment,
      'orderItemsCount': unwrapped.orderItemsCount,
      'orderType': unwrapped.orderType,
      'orderState': unwrapped.orderState,
      'orderSentMessage': unwrapped.orderSentMessage,
      'orderSentAt': unwrapped.orderSentAt,
    } as CustomerOrderListDTO;
  }
}
